import { Button, SelectDropDown, TextField } from '@/components/Common';
import moneyIcon from '@/assets/icons/money.svg';
import dateIcon from '@/assets/icons/date.svg';
import {
  IconPosition,
  TextfieldType,
} from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import { FormMode } from '@/pages/Coupons/coupons.hook';
import React, { FC, useEffect } from 'react';
import { FieldError } from 'react-hook-form';
import { usePackage } from './package.hook';

interface PackageFormProps {
  mode: FormMode;
}

const PackageForm: FC<PackageFormProps> = ({ mode }) => {
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    packageType,
    isUpdatePending,
    isCreatePending,
    handleSubmitUpdate,
    registerUpdateForm,
    updateErrors,
    setUpdateValue,
    onCreatePackage,
    onUpdatePackage,
    isOpenPackageFormModal,
    openPackageFormModal,
    currency,
    subsPackage,
  } = usePackage();

  const isUpdateMode = mode === 'update';

  const onSubmit = isUpdateMode ? onUpdatePackage : onCreatePackage;
  const handleSubmitFn = isUpdateMode ? handleSubmitUpdate : handleSubmit;
  const registerFn = isUpdateMode ? registerUpdateForm : register;
  const errorList = isUpdateMode ? updateErrors : errors;

  useEffect(() => {
    if (isUpdateMode && subsPackage) {
      setUpdateValue('packageName', subsPackage.title);
      setUpdateValue('price', subsPackage.pricing);
      setUpdateValue('currency', subsPackage.currency);
      setUpdateValue('duration', subsPackage.duration);
      setUpdateValue('description', subsPackage.description);
    }
  }, [subsPackage, isUpdateMode, setUpdateValue]);

  return (
    <Modal
      isOpen={isOpenPackageFormModal}
      onClose={openPackageFormModal}
      modalStyle="bg-[#2A2A2A] w-[25rem] px-7"
      headerStyle="bg-[#2A2A2A] mt-1"
    >
      <form
        className="flex flex-col gap-2 overflow-y-auto"
        onSubmit={handleSubmitFn(onSubmit)}
      >
        <h3 className="text-white text-xl font-bold text-center mt-0 mb-5">
          {isUpdateMode ? 'Modifier package' : '  Créer un package'}
        </h3>
        <TextField
          textFieldType={TextfieldType.INPUT}
          placeholder="Nom du package"
          inputStyle={{
            background: '#232323',
            fontSize: '13.8px',
          }}
          name="packageName"
          helpText={(errorList.packageName as FieldError)?.message}
          register={registerFn('packageName')}
          errorStyle="text-red-500"
        />
        <div className="bg-[#232323] rounded-[6px] max-h-12 pl-3">
          <TextField
            textFieldType={TextfieldType.INPUT}
            placeholder="Durée"
            keyfilter="num"
            inputStyle={{ background: '#232323', fontSize: '13.8px' }}
            name="duration"
            icon={<img src={dateIcon} width={'20px'} />}
            iconPosition={IconPosition.LEFT}
            register={registerFn('duration')}
          />
        </div>
        <div className="text-red-500 text-xs">
          {(errorList.duration as FieldError)?.message}
        </div>
        <div className="bg-[#232323] rounded-[6px] max-h-12 pl-3">
          <TextField
            textFieldType={TextfieldType.INPUT}
            placeholder="Prix"
            keyfilter="num"
            inputStyle={{ background: '#232323', fontSize: '13.8px' }}
            name="price"
            icon={<img src={moneyIcon} width={'20px'} />}
            iconPosition={IconPosition.LEFT}
            register={registerFn('price')}
          />
        </div>
        <div className="text-red-500 text-xs">
          {(errorList.price as FieldError)?.message}
        </div>
        <SelectDropDown
          options={packageType || []}
          placeholder="Type"
          name="packageType"
          selectDropDownStyle={{
            borderRadius: '0.375rem',
            color: '#fff',
            padding: ' 0.5rem',
          }}
          initialSelectedOptions={
            isUpdateMode ? { _id: 1, name: subsPackage?.type } : null
          }
          setValue={isUpdateMode ? setUpdateValue : setValue}
          helpText={(errorList.packageType as FieldError)?.message}
          errorStyle="text-red-500"
        />

        <SelectDropDown
          options={currency || []}
          placeholder="Devise"
          name="currency"
          selectDropDownStyle={{
            borderRadius: '0.375rem',
            color: '#fff',
            padding: ' 0.5rem',
          }}
          setValue={isUpdateMode ? setUpdateValue : setValue}
          initialSelectedOptions={
            isUpdateMode ? { _id: 1, name: subsPackage?.currency } : null
          }
          helpText={(errorList.currency as FieldError)?.message}
          errorStyle="text-red-500"
        />
        <TextField
          textFieldType={TextfieldType.TEXTAREA}
          placeholder="Description"
          textAreaStyle={{ background: '#232323', border: 'none' }}
          name="description"
          register={registerFn('description')}
          helpText={(errorList.description as FieldError)?.message}
          errorStyle="text-red-500"
        />

        <div className="text-red-500 text-xs">
          {(errorList.description as FieldError)?.message}
        </div>
        <Button
          title={`${isUpdateMode ? (isUpdatePending ? 'Modification...' : 'Modifier') : isCreatePending ? 'Ajout en cours...' : 'Ajouter'}`}
          className="my-2 mx-1"
          type="submit"
          disabled={isUpdatePending || isCreatePending}
        />
      </form>
    </Modal>
  );
};

export default PackageForm;
